import { render, staticRenderFns } from "./SamplesStatement.vue?vue&type=template&id=49232c70&scoped=true"
import script from "./SamplesStatement.vue?vue&type=script&lang=js"
export * from "./SamplesStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49232c70",
  null
  
)

export default component.exports